import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { PaymentCart } from '@cargos/sprintpay-models';
import { take } from 'rxjs';
import { ConfigService, PaymentRequestService } from 'src/app/shared/services';

@Component({
    selector: 'app-payment-actions-button',
    imports: [MatIconModule, MatProgressSpinnerModule, MatDividerModule, MatButtonModule],
    templateUrl: './payment-actions-button.component.html',
    styleUrl: './payment-actions-button.component.scss',
    standalone: true,
})
export class PaymentActionsButtonComponent {
    public deletingCart = false;
    private chargesURL: string;
    public editable: boolean = true;
    public isLoading = false;
    public destination: string | null = null;
    @Input() paymentRequest: PaymentCart;
    @Output() removePaymentById = new EventEmitter<number>();
    @Output() editPayment = new EventEmitter<PaymentCart>();

    constructor(
        private route: Router,
        private paymentRequestService: PaymentRequestService,
        private configService: ConfigService
    ) {
        this.chargesURL = this.configService.getChargesURL();
        this.editable = this.configService.isEnableChargeEdition();
    }

    edit(): void {
        this.editPayment.emit(this.paymentRequest);
        const urlRedirect = this.configService.forceToRedirectionToCharges() ? '/search-awb/details' : this.chargesURL;

        this.route.navigate([urlRedirect], {
            queryParams: {
                mawb: this.paymentRequest.awb,
                location: this.destination,
            },
        });
    }

    removePayment(paymentCart: PaymentCart): void {
        if (!paymentCart.id) {
            return;
        }
        this.isLoading = true;
        this.paymentRequestService
            .removePaymentRequest(paymentCart.id)
            .pipe(take(1))
            .subscribe((cart: PaymentCart[]) => {
                this.isLoading = false;
                this.removePaymentById.emit(paymentCart.id);
                if (!cart.length) {
                    this.route.navigate([this.chargesURL]);
                }
            });
    }
}
